import { render, staticRenderFns } from "./SharedMediaWithSpaceStorageMediaForm.vue?vue&type=template&id=533d5d85&"
import script from "./SharedMediaWithSpaceStorageMediaForm.vue?vue&type=script&lang=js&"
export * from "./SharedMediaWithSpaceStorageMediaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports